module.exports = __webpack_public_path__ + "img/sparkles.403cd30b.svg";